<app-information-title
  [title]="'P0003607.installation.horloge' | translate"
  [information]="openEnSavoirPlus"
></app-information-title>

<app-two-choices-control
  [firstLabel]="
    'P00039.lighting.functionality.parameters.setting.title.clock.day'
      | translate
  "
  [firstValue]="0"
  [secondLabel]="
    'P00039.lighting.functionality.parameters.setting.title.clock.week'
      | translate
  "
  [secondValue]="1"
  [value]="actionStack!.getValue('esPTypeHorloge')"
  (onChange)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage,
      'esPTypeHorloge',
      $event
    );
    actionStack!.commit()
  "
>
</app-two-choices-control>

@if (this.actionStack!.getValue('esPTypeHorloge') === 0) {
  <app-larged-link
    [name]="
      'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
        | translate
    "
    (onPress)="goToFunctionParametersSettingsClockScreen()"
  >
  </app-larged-link>
} @else {
  <app-larged-link
    [name]="
      'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
        | translate
    "
    (onPress)="goToFunctionParametersSettingClockWeekScreen()"
  >
  </app-larged-link>
}

<app-label-description
  [description]="'P0003607.installation.descriptionHorloge' | translate"
></app-label-description>

@if (actionStack!.getValue('esIMethodeAsservissement') === 0) {
  <app-label-configuration
    [title]="'P0003607.installation.volet' | translate"
    [titleListe]="'P0003607.installation.abaissement' | translate"
    [description]="
      'P0003607.installation.abaissementProduction.description' | translate
    "
    [value]="actionStack!.getValue('esPTauxAbaissement')"
    [liste]="P0003607TauxAbaissement"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage2,
        'esPTauxAbaissement',
        $event
      );
      actionStack!.commit()
    "
  >
  </app-label-configuration>
}

@if (hasProduitP00032()) {
  <app-label-configuration
    [title]="'P0003607.installation.regulation' | translate"
    [titleListe]="'P0003607.installation.regulation.value' | translate"
    [information]="P0003607ESPInstallationClModal"
    [value]="actionStack!.getValue('esPConsigneRx')"
    [liste]="P0003605ConsigneRegulationRxEnum"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage,
        'esPConsigneRx',
        $event
      );
      actionStack!.commit()
    "
  >
  </app-label-configuration>

  <app-label-configuration
    [titleListe]="'P0003607.installation.hysteresis.value' | translate"
    [value]="actionStack!.getValue('esPHysteresisRegulationRx')"
    [liste]="P0003607HysteresisValues"
    [warningMode]="getProductDeviceTableFromPool()"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage,
        'esPHysteresisRegulationRx',
        $event
      );
      actionStack!.commit()
    "
  >
  </app-label-configuration>

  <app-switch-configuration
    [nameCustom]="'P0003607.installation.automaintien.value' | translate"
    [value]="actionStack!.getValue('esIActivationFonctionAutoMaintien') !== 0"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.ElectrolyseurStandard_Installation,
        'esIActivationFonctionAutoMaintien',
        $event ? 1 : 0
      );
      actionStack!.commit()
    "
  >
  </app-switch-configuration>

  <app-label-description
    [description]="'P0003607.installation.regulation.description' | translate"
  ></app-label-description>
}

@if (
  hasProduitP00032() > 0 &&
  actionStack!.getValue(
    'esSTemperatureReferenceDisponibleProtectionHivernage'
  ) === 1
) {
  <app-switch-configuration
    [title]="'P0003607.reglage.hivernage' | translate"
    [nameCustom]="'P0003607.reglage.activationfct' | translate"
    [value]="actionStack!.getValue('esPActivationFonctionHivernage') !== 0"
    [information]="EnSavoirPlusPage"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage,
        'esPActivationFonctionHivernage',
        $event ? 1 : 0
      );
      actionStack!.commit()
    "
  >
  </app-switch-configuration>

  @if (actionStack!.getValue('esPActivationFonctionHivernage') === 1) {
    <app-label-configuration
      [titleListe]="'P0003607.reglage.seuilTemp' | translate"
      [value]="actionStack!.getValue('esPTemperatureHivernage')"
      [liste]="P0003607TemperatureHivernage()"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.ElectrolyseurStandard_Parametrage2,
          'esPTemperatureHivernage',
          $event
        );
        actionStack!.commit()
      "
    >
    </app-label-configuration>
  }

  <app-label-description
    [description]="'P0003607.reglage.hivernage.description' | translate"
  ></app-label-description>
}

<app-switch-configuration
  [title]="'P0003607.installation.comportement' | translate"
  [nameCustom]="'P0003607.installation.comportement.value' | translate"
  [description]="'P0003607.installation.comportement.description' | translate"
  [value]="
    actionStack!.getValue('esIActivationFonctionPrioriteElectrolyse') !== 0
  "
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.ElectrolyseurStandard_Installation,
      'esIActivationFonctionPrioriteElectrolyse',
      $event ? 1 : 0
    );
    actionStack!.commit()
  "
>
</app-switch-configuration>
